
import { format } from "date-fns";

const parsePlainYmd = (ymd) => {
    if (!ymd || "string" !== typeof ymd) return null;
    const [y, m, d] = String(ymd).split("-").map((x) => Number(x));
    if (!y || !m || !d) return null;
    return new Date(y, m - 1, d, 12, 0, 0, 0);
};

const formatCustomDateRange = (startDate, endDate) => {
    const start = parsePlainYmd(startDate);
    const end = parsePlainYmd(endDate);
    if (!start || !end) return "";
    const startLabel = format(start, "d MMMM yyyy");
    const endLabel = format(end, "d MMMM yyyy");
    if (startDate === endDate) return startLabel;
    return `${startLabel} - ${endLabel}`;
};

export const getTableData = (key, type, months, month) => {
    switch(key) {
        case "summary":
            // Dynamic year types like "2024-year", "2026-year", etc.
            if (/^\d{4}-year$/.test(String(type || ""))) {
                return `P&L - ${String(type).slice(0, 4)}`;
            }
            if (type === "current-year") {
                // Prefer deriving year from ytdMonth-style value (e.g. "dec-26") if passed.
                const m = String(month || "");
                const yearSuffix = m.includes("-") ? m.split("-")[1] : "";
                const inferredYear = /^\d{2}$/.test(yearSuffix) ? `20${yearSuffix}` : "";
                return inferredYear ? `P&L - YTD (${inferredYear})` : "P&L - YTD";
            }
            if (type === "ttm") return "P&L - TTM";
            if (type === "mom") return "P&L - Year over Year Comparison";
            if (type === "month") return `P&L - ${(months || []).find((currentMonth) => currentMonth?.value === month)?.label || ""}`;
            if (type === "budget-forecast") return `P&L - Budget x Forecast`;
            return "";
        case "net-income-summary":
            return "Net Income Summary";
        case "contribution-margin":
            return "Contribution Margin";
        case "revenue-breakdown":
            return "Revenue Breakdown";
        case "total-cost-of-goods-sold":
            return "Total Cost of Goods Sold";
        case "total-operating-expenses": 
            return "Total Operating Expenses"
        default: 
            return ""
    }
}

export const getProfitAndLossNewTableData = (key, type, startDate, endDate, customSnapshotLabel = "") => {
    const getPeriodLabel = () => {
        if (type === "this-year-to-date") return "This Year to Date";
        if (type === "last-month") return "Last Month";
        if (type === "last-quarter") return "Last Quarter";
        if (type === "last-year") return "Last Year";
        if (type === "select-month") {
            const start = parsePlainYmd(startDate);
            return start ? format(start, "MMMM yyyy") : "Select Month";
        }
        if (customSnapshotLabel) return customSnapshotLabel;
        if (type === "custom-dates") {
            const rangeLabel = formatCustomDateRange(startDate, endDate);
            return rangeLabel ? `(${rangeLabel})` : "Custom Dates";
        }
        return "";
    };

    const periodLabel = getPeriodLabel();

    switch(key) {
        case "summary":
            return periodLabel ? `P&L — ${periodLabel}` : "P&L";
        case "net-income-summary":
            return periodLabel ? `Net Income Summary — ${periodLabel}` : "Net Income Summary";
        case "contribution-margin":
            return periodLabel ? `Contribution Margin — ${periodLabel}` : "Contribution Margin";
        case "revenue-breakdown":
            return periodLabel ? `Revenue Breakdown — ${periodLabel}` : "Revenue Breakdown";
        case "total-cost-of-goods-sold":
            return periodLabel ? `Total Cost of Goods Sold — ${periodLabel}` : "Total Cost of Goods Sold";
        case "total-operating-expenses": 
            return periodLabel ? `Total Operating Expenses — ${periodLabel}` : "Total Operating Expenses"
        default: 
            return ""
    }
}

export const getProfitAndLossNewTableTitle = (key) => {
    switch(key) {
        case "summary":
            return "P&L";
        case "net-income-summary":
            return "Net Income Summary";
        case "contribution-margin":
            return "Contribution Margin";
        case "revenue-breakdown":
            return "Revenue Breakdown";
        case "total-cost-of-goods-sold":
            return "Total Cost of Goods Sold";
        case "total-operating-expenses":
            return "Total Operating Expenses";
        default:
            return "";
    }
};